import { Grid, Skeleton } from '@radix-ui/themes';
import { MetricHelper } from 'classes/helpers/metric.helper';
import { DataCard } from 'components/common/data-card';
import { t } from 'i18next';
import { SessionHelper } from 'lib_ts/classes/session.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ISessionHit } from 'lib_ts/interfaces/session-hits/i-session-hit';
import { useMemo } from 'react';

export const CommonHitterSessionStats = (props: {
  loading: boolean;
  isMetric: boolean;
  hits: ISessionHit[];
}) => {
  const stats = useMemo(
    () => SessionHelper.getHitsStats(props.hits),
    [props.hits]
  );

  const speedMetricFn = props.isMetric ? MetricHelper.mphToKph : undefined;
  const distanceMetricFn = props.isMetric ? MetricHelper.ftToM : undefined;
  const speedUnit = MetricHelper.getSpeedUnit(props.isMetric, true);
  const distanceUnit = MetricHelper.getDistanceUnit(props.isMetric, true);

  return (
    <Grid
      columns={{ initial: '2', xs: '3', sm: '4', md: '6' }}
      gap={RADIX.FLEX.GAP.XS}
      width={{ initial: '100%', xs: 'auto' }}
    >
      <Skeleton loading={props.loading}>
        <DataCard
          title={t('common.total-shots')}
          value={props.hits.length || '-'}
        />
      </Skeleton>
      <Skeleton loading={props.loading}>
        <DataCard
          title={t('common.avg-ev')}
          value={SessionHelper.formatHitStat(stats.avgExitMPH, {
            roundTo: 1,
            toMetricFn: speedMetricFn,
          })}
          unit={speedUnit}
        />
      </Skeleton>
      <Skeleton loading={props.loading}>
        <DataCard
          title={t('common.max-ev')}
          value={SessionHelper.formatHitStat(stats.maxExitMPH, {
            roundTo: 1,
            toMetricFn: speedMetricFn,
          })}
          unit={speedUnit}
        />
      </Skeleton>
      <Skeleton loading={props.loading}>
        <DataCard
          title={t('common.avg-distance')}
          value={SessionHelper.formatHitStat(stats.avgDistanceFT, {
            roundTo: 1,
            toMetricFn: distanceMetricFn,
          })}
          unit={distanceUnit}
        />
      </Skeleton>
      <Skeleton loading={props.loading}>
        <DataCard
          title={t('common.max-distance')}
          value={SessionHelper.formatHitStat(stats.maxDistanceFT, {
            roundTo: 1,
            toMetricFn: distanceMetricFn,
          })}
          unit={distanceUnit}
        />
      </Skeleton>
      <Skeleton loading={props.loading}>
        <DataCard
          title={t('common.avg-la')}
          value={
            isNaN(stats.avgVLaunchDeg)
              ? '-'
              : `${SessionHelper.formatHitStat(stats.avgVLaunchDeg, {
                  roundTo: 1,
                })}°`
          }
        />
      </Skeleton>
    </Grid>
  );
};
